<template>
    <Breadcrumbs main="Charts" title="Chartist Chart" />
    <div class="container-fluid">
        <div class="row">
            <chartistCharts />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'

const chartistCharts = defineAsyncComponent(() => import("@/components/theme/charts/chartist/chartistCharts.vue"))
</script>